// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__h3Gnf","title":"Modal_title__Nx1+1","description":"Modal_description__hABKW"};